<div>
    <app-breadcrumb
            [firstNode]="{label: 'Patient list', 'url': '/patients'}">
    </app-breadcrumb>
    <div class="box-shadow">
        <div class="card card--box">
            <div class="card--box__header">
                <div class="card--box__header__title">
                    {{ 'Activity' | translate }}
                </div>
                <div class="card--box__header__btnRight">
                    <div class="icon pull-right help-btn">
                        <app-popover [templateType]="HELP_ACTIVITY_DASHBOARD" iconClass="popover-icon--white" containerClass="doctor-home" placement="bottom"></app-popover>
                    </div>
                    <i class="icon export pull-right fas fa-cloud-download-alt" (click)="export()"></i>
                </div>
            </div>
        </div>

        <div class="hidden-xs-up">
            <form id="frmExport" action="{{authService.baseUrl}}activity/export?page=1&items=20" method="POST">
                <textarea name="dateRange" id="inpDateRange"></textarea>
            </form>
        </div>

        <div class="selected-clinic" *ngIf="isSupperAdmin()">
            <div class="selected-clinic__filter-image">
                <i class="fas fa-filter"></i>
            </div>
            <ng-select2
                 class="selected-clinic__filter"
                [width]="'100%'"
                [value]="clinicId"
                [options]="select2Options"
                *ngIf="clinics.length && languageChanged"
                (valueChanged)="onChangeClinic($event)"
                 [data]="clinicsCollection">
            </ng-select2>
            <div class="form-group col-xs-2 ml-1">
                <div class="label mb-0">{{ 'All customers' | translate }}</div>
                <div class="pt-0">
                    <mat-slide-toggle (change)="onChangeClinic(clinicId === 0 ? clinicsCollection[0]['id'] : 0)"
                                      [checked]="clinicId === 0">
                    </mat-slide-toggle>
                </div>
            </div>
        </div>

        <div class="table--grid" >
            <div *ngIf="errorMessageText != ''" class="row" role="alert">
                <div class="col-sm-12">
                    <div class="alert alert-danger">
                        {{ errorMessageText }}
                    </div>
                </div>
            </div>

            <div *ngIf="items['total_general']" class="table--grid__header" (click)="collapse['general'] = !collapse['general'];">
                <div class="row d-flex align-items-center">
                    <div *ngFor="let column of tableColumns" class="{{ column[2] }} whitespace-normal">
                        <span *ngIf="(column[0] === 'official_name'); else infoBlock" class="table--grid__header--name" [class.userviews]="(!isClinicAdmin() && !isSupperAdmin()) || (isSupperAdmin() && clinicId > 0)" [class.collapsed]="collapse['general']">{{'Overviews' | translate}}</span>

                        <ng-template #infoBlock>
                            <span class="total" [class.na]="items['total_general'][column[0]] == 'n.A.'">{{ items['total_general'][column[0]] | formatIfNumber: 2 }}<span *ngIf="column[0] === 'completion_rate'">%</span></span>
                            <br />
                            <span>{{column[1] | translate }}</span>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div [class.collapsed]="collapse['general']" class="table--grid__body" [class.hidden]="(!isClinicAdmin() && !isSupperAdmin()) || (isSupperAdmin() && clinicId > 0)">
                <!--table headers-->
                <div class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div *ngFor="let column of tableColumns" class="{{ column[2] }} whitespace-normal" [class.text-right]="column[0] != 'official_name'" (click)="sort(column[0]);" title="{{ ('Sort by' | translate) }} {{ (column[1] | translate) }}">
                                <span [ngClass]="{'sorted': sortIsActivated && sortedColumn === column[0], 'asc': order === 'asc', 'desc': order === 'desc'}">
                                    {{ column[1] | translate }}
                                    <ng-container *ngIf="column[0] === 'completion_rate'">%</ng-container>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- filter -->

                <div class="row hidden">
                    <div class="col-xs-12">
                        <div class="row">
                            <div *ngFor="let column of tableColumns" class="{{ column[2] }}" [style.overflow]="(column[3] === 'date') ? 'inherit' : ''">
                                <input type="text" *ngIf="column[3] === 'text'" class="form-control" [(ngModel)]="searchInfo[column[0]]" (change)="setFilter($event, column[0])"/>
                                <div *ngIf="column[3] === 'date' && !reset">
                                </div>
                                <div *ngIf="column[3] === 'date' && !reset ">
                                </div>
                            </div>
                        </div>
                        <div class="row reset-filter">
                            <button class="btn btn-primary" (click)="resetFilter()">
                                {{  'Reset Filter' | translate }}
                            </button>
                        </div>
                    </div>
                </div>
                <!--table cells-->
                <div *ngFor="let item of items['general']" class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div *ngFor="let column of tableColumns" class="whitespace-normal questionnaires__item {{ column[2] }} {{ column[4] }}" [class.text-right]="column[0] != 'official_name'" >
                                <div [class.na]="item[column[0]] == 'n.A.'">
                                    {{item[column[0]] | formatIfNumber: 2}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="divider">
            <hr />
        </div>

        <div class="row date-range">
            <div class="col-xs-12 date-range--column">
                <div *ngIf="!reset && dateRangeSelected == 'specified'" class="col-xs-3">
                    <input type="text" daterangepicker [options]="dateRangeOptions" (selected)="onDateInputChanged($event)" class="date-range--column__datepicker" />
                </div>
                <div *ngIf="dateRangeSelected != 'specified'" class="col-xs-1 date-range--column__navigator">
                    <i class="far fa-caret-square-left date-range--btn" (click)="navigateDateRange(-1,checkAvailableDate('prev'))" [class.disabled]="checkAvailableDate('prev')"></i>
                    <i class="far fa-caret-square-right date-range--btn" (click)="navigateDateRange(1,checkAvailableDate('next'))" [class.disabled]="checkAvailableDate('next')"></i>
                </div>
                <div id="date-range-data" [class]="dateRangeSelected == 'specified' ? 'date-range--selected col-xs-7' : 'date-range--selected col-xs-9'">
                    <ng-container [ngSwitch]="dateRangeSelected">
                        <div *ngSwitchCase="'week'">
                            {{'Week' | translate}}: {{dateOptionsFilter.from.format('DD.')}} {{dateOptionsFilter.from.format('MMM') | translate}} {{dateOptionsFilter.from.format('YYYY')}} - {{dateOptionsFilter.to.format('DD.')}} {{dateOptionsFilter.to.format('MMM') | translate}} {{dateOptionsFilter.to.format('YYYY')}}
                        </div>
                        <div *ngSwitchCase="'month'">
                            {{dateOptionsFilter.from.format('MMM') | translate}} {{dateOptionsFilter.from.format('YYYY')}}
                        </div>
                        <div *ngSwitchCase="'quarter'">
                            {{'Quarter' | translate}}: {{dateOptionsFilter.from.format('DD.')}} {{dateOptionsFilter.from.format('MMM') | translate}} {{dateOptionsFilter.from.format('YYYY')}} - {{dateOptionsFilter.to.format('DD.')}} {{dateOptionsFilter.to.format('MMM') | translate}} {{dateOptionsFilter.to.format('YYYY')}}
                        </div>
                        <div *ngSwitchCase="'year'">
                            {{'Year' | translate}} {{dateOptionsFilter.to.format('YYYY')}}
                        </div>
                        <div *ngSwitchCase="'specified'">
                            {{dateOptionsFilter.from.format('DD.')}} {{dateOptionsFilter.from.format('MMM') | translate}} {{dateOptionsFilter.from.format('YYYY')}} - {{dateOptionsFilter.to.format('DD.')}} {{dateOptionsFilter.to.format('MMM') | translate}} {{dateOptionsFilter.to.format('YYYY')}}
                        </div>
                        <div *ngSwitchDefault>{{dateRangeSelected}}</div>
                    </ng-container>
                </div>
                <div class="col-xs-2 table--grid__dateRange">

                    <mat-select [placeholder]="'Week' | translate" [(value)]="dateRangeSelected" (selectionChange)="setDateRange($event.value)">
                        <mat-option *ngFor="let column of filters" [value]="column[0]">
                            {{column[1] | translate}}
                        </mat-option>
                    </mat-select>

                </div>
            </div>
        </div>

        <!-- Tracking -->
        <div class="table--grid" *ngIf="isSupperAdmin() && items && items['tracking']" [class.text-blink]="!items || !items['tracking']">
            <div *ngIf="items['total_tracking']" class="table--grid__header" (click)="collapse['tracking'] = !collapse['tracking'];">
                <div class="row d-flex align-items-center">
                    <div *ngFor="let column of tableColumns_tracking" class="{{ column[2] }} whitespace-normal">
                        <span *ngIf="(column[0] === 'full_name'); else infoBlock" class="table--grid__header--name" [class.userviews]="(!isClinicAdmin() && !isSupperAdmin()) || (isSupperAdmin() && clinicId > 0)" [class.collapsed]="collapse['tracking']">{{'Tracking & Timing' | translate}}</span>

                        <ng-template #infoBlock>
                            <span class="total">{{ items['total_tracking'][column[0]] ? (items['total_tracking'][column[0]] | formatIfNumber: 2) : 0 }}</span> <br />
                            <span>{{column[1] | translate }}</span>
                        </ng-template>
                    </div>
                </div>
            </div>

            <div class="table--grid__body" [class.collapsed]="collapse['tracking']" [class.hidden]="(!isClinicAdmin() && !isSupperAdmin()) || (isSupperAdmin() && clinicId > 0)">
                <!--table headers-->
                <div class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div *ngFor="let column of tableColumns_tracking" class="{{ column[2] }} whitespace-normal" [class.text-right]="column[0] != 'full_name'" (click)="sort(column[0]);" title="{{ ('Sort by' | translate) }} {{ (column[1] | translate) }}">
                                <span [ngClass]="{'sorted': sortIsActivated && sortedColumn === column[0], 'asc': order === 'asc', 'desc': order === 'desc'}">
                                    {{ column[1] | translate }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- filter -->

                <!--table cells-->
                <div *ngFor="let item of items['tracking']" class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div *ngFor="let column of tableColumns_tracking" class="whitespace-normal questionnaires__item {{ column[2] }} {{ column[4] }}" [class.text-right]="column[0] != 'full_name'">
                                <div>
                                    {{item[column[0]]  | formatIfNumber: 2}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Self report -->
        <div class="table--grid" *ngIf="items && items['self_report']">
            <div *ngIf="items['total_self_report']" class="table--grid__header" (click)="collapse['sr'] = !collapse['sr'];">
                <div class="row d-flex align-items-center">
                    <div *ngFor="let column of tableColumns_2" class="{{ column[2] }} whitespace-normal">
                        <span *ngIf="(column[0] === 'full_name'); else infoBlock" class="table--grid__header--name" [class.userviews]="(!isClinicAdmin() && !isSupperAdmin()) || (isSupperAdmin() && clinicId > 0)" [class.collapsed]="collapse['sr']">{{'Self Evaluation' | translate}}</span>

                        <ng-template #infoBlock>
                            <span class="total">{{ items['total_self_report'][column[0]] ? (items['total_self_report'][column[0]] | formatIfNumber: 2) : 0 }}</span> <br />
                            <span>{{column[1] | translate }}</span>
                        </ng-template>
                    </div>
                </div>
            </div>

            <div class="table--grid__body" [class.collapsed]="collapse['sr']" [class.hidden]="(!isClinicAdmin() && !isSupperAdmin()) || (isSupperAdmin() && clinicId > 0)">
                <!--table headers-->
                <div class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div *ngFor="let column of tableColumns_2" class="{{ column[2] }} whitespace-normal" [class.text-right]="column[0] != 'full_name'" (click)="sort(column[0]);" title="{{ ('Sort by' | translate) }} {{ (column[1] | translate) }}">
                                <span [ngClass]="{'sorted': sortIsActivated && sortedColumn === column[0], 'asc': order === 'asc', 'desc': order === 'desc'}">
                                    {{ column[1] | translate }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- filter -->

                <!--table cells-->
                <div *ngFor="let item of items['self_report']" class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div *ngFor="let column of tableColumns_2" class="whitespace-normal questionnaires__item {{ column[2] }} {{ column[4] }}" [class.text-right]="column[0] != 'full_name'">
                                <div>
                                    {{item[column[0]] | formatIfNumber: 2}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Clinic validation -->
        <div class="table--grid" *ngIf="isSupperAdmin() && items && items['clinic_validation']">
            <div *ngIf="items['total_clinic_validation']" class="table--grid__header" (click)="collapse['cv'] = !collapse['cv'];">
                <div class="row d-flex align-items-center">
                    <div *ngFor="let column of tableColumns_cv" class="{{ column[2] }} whitespace-normal">
                        <span *ngIf="(column[0] === 'full_name'); else infoBlock" class="table--grid__header--name" [class.userviews]="(!isClinicAdmin() && !isSupperAdmin()) || (isSupperAdmin() && clinicId > 0)" [class.collapsed]="collapse['cv']">{{'Clinical validations' | translate}}</span>

                        <ng-template #infoBlock>
                            <span class="total">{{ items['total_clinic_validation'][column[0]] ? (items['total_clinic_validation'][column[0]] | formatIfNumber: 2) : 0 }}</span> <br />
                            <span>{{column[1] | translate }}</span>
                        </ng-template>
                    </div>
                </div>
            </div>

            <div class="table--grid__body" [class.collapsed]="collapse['cv']" [class.hidden]="(!isClinicAdmin() && !isSupperAdmin()) || (isSupperAdmin() && clinicId > 0)">
                <!--table headers-->
                <div class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div *ngFor="let column of tableColumns_cv" class="{{ column[2] }} whitespace-normal" [class.text-right]="column[0] != 'full_name'" (click)="sort(column[0]);" title="{{ ('Sort by' | translate) }} {{ (column[1] | translate) }}">
                                <span [ngClass]="{'sorted': sortIsActivated && sortedColumn === column[0], 'asc': order === 'asc', 'desc': order === 'desc'}">
                                    {{ column[1] | translate }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- filter -->

                <!--table cells-->
                <div *ngFor="let item of items['clinic_validation']" class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div *ngFor="let column of tableColumns_cv" class="whitespace-normal questionnaires__item {{ column[2] }} {{ column[4] }}" [class.text-right]="column[0] != 'full_name'">
                                <div>
                                    {{item[column[0]] | formatIfNumber: 2}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Proposal -->
        <div class="table--grid" *ngIf="items && items['proposal']">
            <div *ngIf="items['total_proposal']" class="table--grid__header" (click)="collapse['proposal'] = !collapse['proposal'];">
                <div class="row d-flex align-items-center">
                    <div *ngFor="let column of tableColumns_3" class="{{ column[2] }} whitespace-normal">
                        <span *ngIf="column[0] == 'full_name'" class="table--grid__header--name" [class.userviews]="(!isClinicAdmin() && !isSupperAdmin()) || (isSupperAdmin() && clinicId > 0)" [class.collapsed]="collapse['proposal']">{{'Diagnosis proposals' | translate}}</span>
                        <span *ngIf="column[0] == 'most_selected_diagnosis' && items['total_proposal']['most_selected_diagnosis']">
                            <div class="row">
                                <div class="col-xs-8 proposal-name">
                                    <span>{{ items['total_proposal'][column[0]]['code'] }} {{ items['total_proposal'][column[0]]['name_' + language] }}</span>
                                    <span>{{ 'Most selected diagnosis' | translate }}</span>
                                </div>
                                <div class="col-xs-4">
                                    <span class="total">{{ items['total_proposal'][column[0]]['total'] | formatIfNumber: 2 }}</span> <br />
                                    <span>{{'Assigned' | translate }}</span>
                                </div>
                            </div>
                        </span>

                        <ng-container *ngIf="(column[0] != 'full_name' && column[0] != 'most_selected_diagnosis')">
                            <span class="total">{{ items['total_proposal'][column[0]] ? (items['total_proposal'][column[0]] | formatIfNumber: 2) : 0 }}</span> <br />
                            <span>{{column[1] | translate }}</span>
                        </ng-container>
                    </div>
                </div>
            </div>

            <div class="table--grid__body" [class.collapsed]="collapse['proposal']"[class.hidden]="(!isClinicAdmin() && !isSupperAdmin()) || (isSupperAdmin() && clinicId > 0)">
                <!--table headers-->
                <div class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div *ngFor="let column of tableColumns_3" class="{{ column[2] }} whitespace-normal" [class.text-right]="column[0] != 'full_name'" (click)="sort(column[0]);" title="{{ ('Sort by' | translate) }} {{ (column[1] | translate) }}">
                                <span [ngClass]="{'sorted': sortIsActivated && sortedColumn === column[0], 'asc': order === 'asc', 'desc': order === 'desc', 'hidden' : (column[0] == 'most_selected_diagnosis' && !isSupperAdmin())}">
                                    {{ column[1] | translate }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- filter -->

                <!--table cells-->
                <div *ngFor="let item of items['proposal']" class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div *ngFor="let column of tableColumns_3" class="whitespace-normal questionnaires__item {{ column[2] }} {{ column[4] }}" [class.text-right]="column[0] != 'full_name'">
                                <div *ngIf="column[0] !== 'most_selected_diagnosis'">
                                    {{item[column[0]] | formatIfNumber: 2}}
                                </div>
                                <div class="row" *ngIf="column[0] === 'most_selected_diagnosis' && item[column[0]]">
                                    <div class="col-xs-8 proposal-name">
                                        <span>{{ item[column[0]]['code'] }} {{ item[column[0]]['name_' + language] }}</span>
                                    </div>
                                    <div class="col-xs-4 proposal-name">
                                        <span class="total">{{ item[column[0]]['total'] }}</span>
                                        <span>{{'Assigned' | translate }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ng-container *ngIf="isSupperAdmin()">
            <!-- Repeated SR -->
            <div class="table--grid" *ngIf="isSupperAdmin() && items && items['repeated_sr']">
                <div *ngIf="items['total_repeated_sr']" class="table--grid__header" (click)="collapse['repeated_sr'] = !collapse['repeated_sr'];">
                    <div class="row d-flex align-items-center">
                        <div *ngFor="let column of tableColumns_repeated_sr" class="{{ column[2] }} whitespace-normal">
                            <span *ngIf="(column[0] === 'full_name'); else infoBlock" class="table--grid__header--name" [class.userviews]="(!isClinicAdmin() && !isSupperAdmin()) || (isSupperAdmin() && clinicId > 0)" [class.collapsed]="collapse['repeated_sr']">{{'Repeated measurements' | translate}}</span>

                            <ng-template #infoBlock>
                                <span class="total">{{ items['total_repeated_sr'][column[0]] ? (items['total_repeated_sr'][column[0]] | formatIfNumber: 2) : 0 }}</span> <br />
                                <span>{{column[1] | translate }}</span>
                            </ng-template>
                        </div>
                    </div>
                </div>

                <div class="table--grid__body" [class.collapsed]="collapse['repeated_sr']" [class.hidden]="(!isClinicAdmin() && !isSupperAdmin()) || (isSupperAdmin() && clinicId > 0)">
                    <!--table headers-->
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="row">
                                <div *ngFor="let column of tableColumns_repeated_sr" class="{{ column[2] }} whitespace-normal" [class.text-right]="column[0] != 'full_name'" (click)="sort(column[0]);" title="{{ ('Sort by' | translate) }} {{ (column[1] | translate) }}">
                                    <span [ngClass]="{'sorted': sortIsActivated && sortedColumn === column[0], 'asc': order === 'asc', 'desc': order === 'desc'}">
                                        {{ column[1] | translate }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- filter -->

                    <!--table cells-->
                    <div *ngFor="let item of items['repeated_sr']" class="row">
                        <div class="col-xs-12">
                            <div class="row">
                                <div *ngFor="let column of tableColumns_repeated_sr" class="whitespace-normal questionnaires__item {{ column[2] }} {{ column[4] }}" [class.text-right]="column[0] != 'full_name'">
                                    <div>
                                        {{item[column[0]] | formatIfNumber: 2}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Compare Action -->
            <div class="table--grid" *ngIf="isSupperAdmin() && items && items['compare_action']">
                <div *ngIf="items['total_compare_action']" class="table--grid__header" (click)="collapse['compare_action'] = !collapse['compare_action'];">
                    <div class="row d-flex align-items-center">
                        <div *ngFor="let column of tableColumns_compare_action" class="{{ column[2] }} whitespace-normal">
                            <span *ngIf="(column[0] === 'full_name'); else infoBlock" class="table--grid__header--name" [class.userviews]="(!isClinicAdmin() && !isSupperAdmin()) || (isSupperAdmin() && clinicId > 0)" [class.collapsed]="collapse['compare_action']">{{'Compare views' | translate}}</span>

                            <ng-template #infoBlock>
                                <span class="total">{{ items['total_compare_action'][column[0]] ? (items['total_compare_action'][column[0]] | formatIfNumber: 2) : 0 }}</span> <br />
                                <span>{{column[1] | translate }}</span>
                            </ng-template>
                        </div>
                    </div>
                </div>

                <div class="table--grid__body" [class.collapsed]="collapse['compare_action']" [class.hidden]="(!isClinicAdmin() && !isSupperAdmin()) || (isSupperAdmin() && clinicId > 0)">
                    <!--table headers-->
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="row">
                                <div *ngFor="let column of tableColumns_compare_action" class="{{ column[2] }} whitespace-normal" [class.text-right]="column[0] != 'full_name'" (click)="sort(column[0]);" title="{{ ('Sort by' | translate) }} {{ (column[1] | translate) }}">
                                    <span [ngClass]="{'sorted': sortIsActivated && sortedColumn === column[0], 'asc': order === 'asc', 'desc': order === 'desc'}">
                                        {{ column[1] | translate }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- filter -->

                    <!--table cells-->
                    <div *ngFor="let item of items['compare_action']" class="row">
                        <div class="col-xs-12">
                            <div class="row">
                                <div *ngFor="let column of tableColumns_compare_action" class="whitespace-normal questionnaires__item {{ column[2] }} {{ column[4] }}" [class.text-right]="column[0] != 'full_name'">
                                    <div>
                                        {{item[column[0]] | formatIfNumber: 2}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Download Info -->
            <div class="table--grid" *ngIf="isSupperAdmin() && items && items['download_info'] && poolClinicId === clinicId">
                <div *ngIf="items['total_download_info']" class="table--grid__header" (click)="collapse['download_info'] = !collapse['download_info'];">
                    <div class="row d-flex align-items-center">
                        <div *ngFor="let column of tableColumns_download_info" class="{{ column[2] }} whitespace-normal">
                            <span *ngIf="(column[0] === 'full_name'); else infoBlock" class="table--grid__header--name" [class.userviews]="(!isClinicAdmin() && !isSupperAdmin()) || (isSupperAdmin() && clinicId > 0)" [class.collapsed]="collapse['download_info']">{{'Download info' | translate}}</span>

                            <ng-template #infoBlock>
                                <span class="total">{{ items['total_download_info'][column[0]] ? items['total_download_info'][column[0]] : 0 }}</span> <br />
                                <span>{{column[1] | translate }}</span>
                            </ng-template>
                        </div>
                    </div>
                </div>

                <div class="table--grid__body" [class.collapsed]="collapse['download_info']" [class.hidden]="(!isClinicAdmin() && !isSupperAdmin()) || (isSupperAdmin() && clinicId > 0)">
                    <!--table headers-->
                    <div class="row">
                        <div class="col-xs-12">
                            <div class="row">
                                <div *ngFor="let column of tableColumns_download_info" class="{{ column[2] }} whitespace-normal" [class.text-right]="column[0] != 'full_name'" (click)="sort(column[0]);" title="{{ ('Sort by' | translate) }} {{ (column[1] | translate) }}">
                                    <span [ngClass]="{'sorted': sortIsActivated && sortedColumn === column[0], 'asc': order === 'asc', 'desc': order === 'desc'}">
                                        {{ column[1] | translate }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- filter -->

                    <!--table cells-->
                    <div *ngFor="let item of items['download_info']" class="row">
                        <div class="col-xs-12">
                            <div class="row">
                                <div *ngFor="let column of tableColumns_download_info" class="whitespace-normal questionnaires__item {{ column[2] }} {{ column[4] }}" [class.text-right]="column[0] != 'full_name'">
                                    <div>
                                        {{item[column[0]] | formatIfNumber: 2}}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <!-- Service Provider Action -- Temporary disable-->
        <!-- <div class="table--grid" *ngIf="items && items['service_provider_action'] && poolClinicId === clinicId">
            <div *ngIf="items['total_service_provider_action']" class="table--grid__header" (click)="collapse['service_provider_action'] = !collapse['service_provider_action'];">
                <div class="row d-flex align-items-center">
                    <div *ngFor="let column of tableColumns_service_provider_action" class="{{ column[2] }} whitespace-normal">
                        <span *ngIf="(column[0] === 'diga_name'); else infoBlock" class="table--grid__header--name" [class.userviews]="(!isClinicAdmin() && !isSupperAdmin()) || (isSupperAdmin() && clinicId > 0)" [class.collapsed]="collapse['service_provider_action']">{{'DIGA' | translate}}</span>
                        <ng-template #infoBlock>
                            <span class="total">{{ items['total_service_provider_action'][column[0]] ? items['total_service_provider_action'][column[0]] : 0 }}</span> <br />
                            <span>{{column[1] | translate }}</span>
                        </ng-template>
                    </div>
                </div>
            </div>

            <div class="table--grid__body" [class.collapsed]="collapse['service_provider_action']">
                <div class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div *ngFor="let column of tableColumns_service_provider_action" class="{{ column[2] }} whitespace-normal" [class.text-right]="column[0] != 'diga_name'" (click)="sort(column[0]);" title="{{ ('Sort by' | translate) }} {{ (column[1] | translate) }}">
                                <span [ngClass]="{'sorted': sortIsActivated && sortedColumn === column[0], 'asc': order === 'asc', 'desc': order === 'desc'}">
                                    {{ column[1] | translate }}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngFor="let item of items['service_provider_action']" class="row">
                    <div class="col-xs-12">
                        <div class="row">
                            <div *ngFor="let column of tableColumns_service_provider_action" class="whitespace-normal questionnaires__item {{ column[2] }} {{ column[4] }}" [class.text-right]="column[0] != 'diga_name'">
                                <div>
                                    <span *ngIf="column[0] === 'diga_name'">{{item[column[0] + '_' + language]}}</span>
                                    <span *ngIf="column[0] !== 'diga_name'">{{item[column[0]]}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
    <pagination-component *ngIf="!paginationHidden" [(page)]="currentPage" [total]="totalItems" [perPage]="itemsPerPage" [limit]="maxSize" boundaryNumbers="1" boundaryLinks="true" (pageChange)="paginate($event)" #pagination></pagination-component>
</div>
